import { render, staticRenderFns } from "./detailsInfoVant.vue?vue&type=template&id=209dd5b6&scoped=true&"
import script from "./detailsInfoVant.vue?vue&type=script&lang=js&"
export * from "./detailsInfoVant.vue?vue&type=script&lang=js&"
import style0 from "./detailsInfoVant.vue?vue&type=style&index=0&id=209dd5b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209dd5b6",
  null
  
)

export default component.exports